import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Card, Badge, Th, Td, Empty, fmtDate } from "./ui";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const ROLES = ["superadmin", "administrator", "sales", "finance", "support", "read_only"];

export default function Users() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [adding, setAdding] = useState(null);
  const canManage = user?.role === "superadmin";

  const load = () => api.get("/admin/users").then((r) => setRows(r.data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { await api.post("/admin/users", adding); toast.success("Gebruiker aangemaakt"); setAdding(null); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const changeRole = async (id, role) => { try { await api.patch(`/admin/users/${id}`, { role }); toast.success("Rol bijgewerkt"); load(); } catch (e) { toast.error(apiErr(e)); } };

  const inp = "w-full rounded-xl border border-white/10 bg-sfc-night px-3 py-2 text-sm text-white focus:border-sfc-orange focus:outline-none";

  return (
    <div>
      <PageHeader title="Gebruikers & rollen" subtitle="Role-based toegang tot het portaal">
        {canManage && <button data-testid="add-user-btn" onClick={() => setAdding({ email: "", password: "", name: "", role: "read_only" })} className="flex items-center gap-2 rounded-full bg-gradient-to-r from-sfc-orange to-sfc-red px-5 py-2.5 text-sm font-semibold text-white"><Plus size={16} /> Nieuwe gebruiker</button>}
      </PageHeader>

      <Card>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-white/10"><tr><Th>E-mail</Th><Th>Naam</Th><Th>Rol</Th><Th>Actief</Th><Th>Laatste login</Th></tr></thead>
            <tbody>
              {rows.map((u) => (
                <tr key={u.id} className="border-b border-white/5" data-testid={`user-row-${u.email}`}>
                  <Td>{u.email}</Td><Td>{u.name}</Td>
                  <Td>{canManage ? (
                    <select value={u.role} onChange={(e) => changeRole(u.id, e.target.value)} className="rounded-lg border border-white/10 bg-sfc-night px-2 py-1 text-xs text-white focus:outline-none">
                      {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
                    </select>
                  ) : <Badge status="approved" />}</Td>
                  <Td><Badge status={u.is_active ? "approved" : "archived"} /></Td>
                  <Td className="text-white/50">{fmtDate(u.last_login_at)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <Empty text="Geen gebruikers" />}
        </div>
      </Card>

      {adding && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" onClick={() => setAdding(null)}>
          <div className="w-full max-w-md rounded-3xl border border-white/10 bg-[#0e0722] p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between"><h2 className="font-display text-xl text-white">Nieuwe gebruiker</h2><button onClick={() => setAdding(null)}><X className="text-white/60" /></button></div>
            <div className="mt-5 space-y-3">
              <input className={inp} placeholder="E-mail" value={adding.email} onChange={(e) => setAdding({ ...adding, email: e.target.value })} />
              <input className={inp} placeholder="Naam" value={adding.name} onChange={(e) => setAdding({ ...adding, name: e.target.value })} />
              <input className={inp} type="password" placeholder="Wachtwoord" value={adding.password} onChange={(e) => setAdding({ ...adding, password: e.target.value })} />
              <select className={inp} value={adding.role} onChange={(e) => setAdding({ ...adding, role: e.target.value })}>{ROLES.map((r) => <option key={r} value={r}>{r}</option>)}</select>
            </div>
            <button data-testid="save-user-btn" onClick={create} className="mt-6 w-full rounded-full bg-gradient-to-r from-sfc-orange to-sfc-red px-6 py-3 text-sm font-semibold text-white">Aanmaken</button>
          </div>
        </div>
      )}
    </div>
  );
}
